import React from "react";
import styles from "./styles.module.css";
import backgroundImage from "../images/TwoCardsTeenPatti/tableBg.jpg";
import newRoundImg from "../images/TwoCardsTeenPatti/New_Round.svg";
import welcome from "../images/TwoCardsTeenPatti/welcome.gif";
import ideal from "../images/TwoCardsTeenPatti/idle.gif";
import clapping from "../images/TwoCardsTeenPatti/clapping.gif";
import crown from "../images/TwoCardsTeenPatti/crown.png";
import closedCard from "../images/TwoCardsTeenPatti/closed-card.jpg";
import card1 from "../images/cards/4CC.webp";
import card2 from "../images/cards/6DD.webp";
import card3 from "../images/cards/6SS.webp";
import card4 from "../images/cards/JDD.webp";
import { cards } from "../images/index";
import GameAreaLoader from "../../Loader/GameAreaLoader";
import useGameScreenLoader from "../../../api/useGameScreenLoader";
import useRoundLoader from "../../../api/useRoundLoader";

const parseHand = (hand) => {
  try {
    if (typeof hand === 'string') {
      const cleanedHand = hand.replace(/[\[\]]/g, '').split(',').map(card => card.trim());
      return cleanedHand.filter(card => card && /^(10|[2-9]|[JQKA])[HSCD]$/i.test(card));
    }
    return [];
  } catch (error) {
    return [];
  }
};

export default function GameScreen({ bettingClosed, animationTime, socketData, remainingTime, onAnimStart, onAnimEnd }) {
const roundId = socketData?.roundId;
const settlement = socketData?.settlement;

const { gameScreenLoader, processingLoader } = useGameScreenLoader(roundId, !!settlement, 5000);

  const prevBettingClosedRef = React.useRef(false);



  React.useEffect(() => {
    if (bettingClosed && !prevBettingClosedRef.current) {
      prevBettingClosedRef.current = true;
      onAnimStart?.();
    }
    if (!bettingClosed && prevBettingClosedRef.current) {
      prevBettingClosedRef.current = false;
      onAnimEnd?.();
    }
  }, [bettingClosed, onAnimStart, onAnimEnd]);

  const mapCardStringToAsset = (cardString) => {
    if (!cardString || typeof cardString !== 'string') return closedCard;
    const raw = cardString.trim().toUpperCase();

    const suitMap = { 'H': 'H', 'D': 'D', 'S': 'S', 'C': 'C', 'HEARTS': 'H', 'DIAMONDS': 'D', 'SPADES': 'S', 'CLUBS': 'C' };
    const rankMap = {
      '1': 'A', 'ACE': 'A', 'A': 'A',
      '2': '2', '3': '3', '4': '4', '5': '5',
      '6': '6', '7': '7', '8': '8', '9': '9',
      '10': '10', 'T': '10',
      'J': 'J', 'JACK': 'J',
      'Q': 'Q', 'QUEEN': 'Q',
      'K': 'K', 'KING': 'K'
    };

    let rank = '';
    let suit = '';

    if (/^(10|[2-9JQKA])[HSDC]$/.test(raw)) {
      if (raw.startsWith('10')) { rank = '10'; suit = raw[2]; }
      else { rank = raw[0]; suit = raw[1]; }
    } else if (/^(10|[2-9JQKA])[HSDC]{2}$/.test(raw)) {
      if (raw.startsWith('10')) { rank = '10'; suit = raw[2]; }
      else { rank = raw[0]; suit = raw[1]; }
    } else if (/^(10|[2-9JQKA])\s[HSDC]$/.test(raw)) {
      const parts = raw.split(' ');
      rank = parts[0]; suit = parts[1];
    } else {
      console.warn('Unknown card format:', cardString);
      return closedCard;
    }

    rank = rankMap[rank] || rank;
    suit = suitMap[suit] || suit;

    if (!rank || !suit) {
      console.warn('Could not parse rank/suit from:', cardString);
      return closedCard;
    }

    const assetKey = `${rank}${suit}${suit}`;
    const keysToTry = [assetKey, `${assetKey}.webp`, assetKey.toLowerCase(), `${assetKey.toLowerCase()}.webp`];

    for (const key of keysToTry) {
      if (cards[key]) return cards[key];
    }

    console.warn('Card asset not found for:', cardString, '→ tried key:', assetKey);
    return closedCard;
  };

  const getWinnerName = (outcome) => {
    if (outcome === "PLAYER_1" || outcome === "PLAYER_A") return "PLAYER A";
    if (outcome === "PLAYER_2" || outcome === "PLAYER_B") return "PLAYER B";
    return "";
  };

  // ab stage backend flags se, animationTime guess se nahi
  const stage = !bettingClosed
    ? 'welcome'
    : settlement?.clapping
      ? 'clapping'
      : 'idle';

  const currentGif =
    stage === 'welcome' ? welcome :
      stage === 'clapping' ? clapping :
        ideal;
const showCards = stage !== 'welcome'; 
  const playerACard1 = showCards ? settlement?.playerACard1 : null;
  const playerACard2 = showCards ? settlement?.playerACard2 : null;
  const playerBCard1 = showCards ? settlement?.playerBCard1 : null;
  const playerBCard2 = showCards ? settlement?.playerBCard2 : null;

  return (
    <GameAreaLoader showLoader={gameScreenLoader}>
      <div className={styles.gameContainer}>
        <div className={styles.mainGameArea}>
          <div className={styles.videoArea}>
            <div className={styles.videoContainer}>
              <img
                src={backgroundImage}
                alt="Two Card Teen Patti"
                className={styles.backgroundImage}
                draggable={false}
              />
              <div className={styles.gifOverlay}>
                <img
                  src={currentGif}
                  alt={stage + ' gif'}
                  className={styles.gifImage}
                  draggable={false}
                  style={{ objectFit: 'contain' }}
                />
              </div>
              <div className={styles.cardsContainer}>
                <div className={`${styles.playerSection} ${styles.playerASection}`}>
                  <div className={styles.playerCards}>
                    {[playerACard1, playerACard2].map((card, index) => (
                      <div key={`playerA-${index}`} className={styles.cardWrapper}>
                        <img
                          src={card ? mapCardStringToAsset(card) : closedCard}
                          alt={`PlayerA-Card${index + 1}`}
                          className={styles.cardImage}
                          draggable={false}
                        />
                      </div>
                    ))}
                  </div>
                  <span className={styles.playerLabel}>PLAYER A</span>
                </div>
                <div className={styles.divider}></div>
                <div className={`${styles.playerSection} ${styles.playerBSection}`}>
                  <div className={styles.playerCards}>
                    {[playerBCard1, playerBCard2].map((card, index) => (
                      <div key={`playerB-${index}`} className={styles.cardWrapper}>
                        <img
                          src={card ? mapCardStringToAsset(card) : closedCard}
                          alt={`PlayerB-Card${index + 1}`}
                          className={styles.cardImage}
                          draggable={false}
                        />
                      </div>
                    ))}
                  </div>
                  <span className={styles.playerLabel}>PLAYER B</span>
                </div>
                {stage === 'clapping' && settlement?.outcome && (
                  <div className={styles.winnerAnimation}>
                    <img src={crown} alt="Crown" className={styles.crownImage} />
                    <span className={styles.winnerTextBottom}>
                      Winner: {getWinnerName(settlement.outcome)}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {processingLoader && (
  <div className="dataProcessingOverlay">
    <div className="cardSpinner" />
  </div>
)}
      </div>
    </GameAreaLoader>
  );
}